import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { B2cRoutingModule } from './b2c-routing.module';
import { ToastModule } from 'primeng';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { B2cWidgetComponent } from '../../components/b2c/b2c-widget.component';
import { GoogleMapDragDropComponent } from '../../components/google-map-dragdrop/google-map-dragdrop.component';
import { AgmCoreModule } from '@agm/core';
import { B2cAddressConfirmationComponent } from '../../components/b2c/b2c-address-confirmation.component';
import { B2cPriceDisplayComponent } from '../../components/b2c/b2c-price-display.component';
import { VMEComponentsModule } from '../../vme-components.module';
import { NgxStripeModule } from 'ngx-stripe';
import { B2cConfirmationComponent } from '../../components/b2c/b2c-confirmation.component';
import { B2cPaymentConfirmationComponent } from '../../components/b2c/b2c-payment-confirmation.component';
import { DecimalPipe } from '@angular/common';
import { BankersRoundPipe } from '../../pipes/bankers-round.pipe';

/**
 * Account module, handles /account routes
 * Used for login, password reset, new user requests
 */
@NgModule({
  imports: [
    B2cRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    ToastModule,
    AgmCoreModule,
    RecaptchaFormsModule,
    VMEComponentsModule,
    NgxStripeModule,
    B2cConfirmationComponent,
  ],
  declarations: [
    B2cWidgetComponent,
    B2cAddressConfirmationComponent,
    B2cPriceDisplayComponent,
    B2cPaymentConfirmationComponent,
    GoogleMapDragDropComponent,
  ],
  providers: [BankersRoundPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class B2cModule {}
